/* Panambi 360 · Test A/B — medición en la tienda (motor v2).
 *
 * La asignación A/B la hace p360-ab-head.liquid en el <head> (sin parpadeo). Este archivo:
 *  1. Exposición: avisa de qué versión ha visto la clienta en esta ficha.
 *  2. Añadir a la cesta desde la ficha, con la versión vista.
 *  3. Guarda la versión en un atributo oculto del carrito (_p360_ab), que llega al pedido de Shopify:
 *     así las compras de cada versión se cuentan con pedidos reales, no con estimaciones.
 *  4. (v2) Contador propio: avisa al portal Panambi 360 (Cloudflare) de cada visita y cada «añadir a la cesta»
 *     de cada versión, una vez por sesión y test. Solo se envía el test, la versión y el evento: nada de la clienta.
 *  5. (v2) Cambia el texto del botón de compra si la versión B lo pide.
 * Los eventos se publican también como eventos de cliente de Shopify (píxel «Panambi 360» → GA4) y a dataLayer.
 * Las visitas de previsualización (?p360_ab=…) no se miden.
 */
// Versión B con otra foto principal: el carrusel de Ella (slick) arranca en esa foto. También en la vista previa.
(function () {
  const n = window.P360AB && window.P360AB.gallery;
  if (!n) return;
  let tries = 0;
  const go = () => {
    const $ = window.jQuery, el = $ && $('.productView-nav[data-image-gallery-main]');
    if (el && el.length && el.hasClass('slick-initialized')) { el.slick('slickGoTo', n - 1, true); return true; }
    return false;
  };
  if (!go()) { const iv = setInterval(() => { if (go() || ++tries > 60) clearInterval(iv); }, 100); }
})();

// (v4) Precio con descuento en la versión B: se enseña el precio rebajado con el original tachado y se aplica sola el código
// de descuento de la prueba (/discount/CODIGO), que Shopify usa en la cesta y en el pago. Si cambia la talla, se vuelve a pintar.
(function () {
  const pd = +(window.P360AB && window.P360AB.pd) || 0, code = (window.P360AB && window.P360AB.pc) || '';
  const root = document.documentElement, done = () => root.classList.add('p360-price-done');
  if (!(pd > 0 && pd < 90)) { done(); return; }
  const fmt = (c) => (c % 100 ? (c / 100).toFixed(2).replace('.', ',') : String(Math.round(c / 100))) + '€';
  const cents = (txt) => { const m = String(txt || '').replace(/\./g, '').replace(',', '.').match(/(\d+(?:\.\d+)?)/); return m ? Math.round(parseFloat(m[1]) * 100) : 0; };
  const paint = () => {
    document.querySelectorAll('.productView-price .price, .sticky-price').forEach((box) => {
      if (box.getAttribute('data-p360-pd') === String(pd)) return;
      const last = box.querySelector('[data-last]'), reg = box.querySelector('.price__regular .price-item, .price-item--regular') || box;
      const base = last ? +last.getAttribute('data-last') : cents(reg.textContent); if (!base) return;
      const now = Math.round(base * (100 - pd) / 100);
      box.setAttribute('data-p360-pd', String(pd));
      box.innerHTML = `<span class="p360-pd"><s>${fmt(base)}</s> <b>${fmt(now)}</b> <em>−${pd} %</em></span>`;
    });
    done();
  };
  const css = document.createElement('style');
  css.textContent = '.p360-pd s{opacity:.55;margin-right:6px}.p360-pd b{color:#9b1c1c}.p360-pd em{font-style:normal;font-size:.8em;margin-left:6px;background:#9b1c1c;color:#fff;padding:1px 6px;border-radius:3px}';
  document.head.appendChild(css);
  paint(); document.addEventListener('DOMContentLoaded', paint); setTimeout(done, 2500);
  new MutationObserver(() => { document.querySelectorAll('.productView-price .price, .sticky-price').forEach((b) => { if (!b.querySelector('.p360-pd')) b.removeAttribute('data-p360-pd'); }); paint(); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (code && !(window.P360AB && window.P360AB.preview)) {
    let k = 'p360_pc_' + code, seen = null; try { seen = sessionStorage.getItem(k); } catch (_) {}
    if (!seen) fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(() => { try { sessionStorage.setItem(k, '1'); } catch (_) {} }).catch(() => {});
  }
})();


// (v3) Fotos nuevas en la versión B: sustituyen a las primeras fotos de la galería (también en las copias del carrusel y en las
// miniaturas). Hasta que se cambian, esas fotos están ocultas (CSS del head) para que no se vea la foto original un instante.
(function () {
  const L = (window.P360AB && window.P360AB.nimg) || [];
  if (!L.length) return;
  const root = document.documentElement, ok = /^https:\/\/(cdn\.shopify\.com|panambicollection\.com\/cdn)\//;
  const urls = L.filter((u) => ok.test(u));
  const swap = () => {
    let n = 0;
    document.querySelectorAll('.productView-nav .productView-image').forEach((s) => {
      const i = +(s.getAttribute('data-index') || 0), u = urls[i - 1]; if (!u) return;
      s.querySelectorAll('img').forEach((im) => { if (im.getAttribute('data-p360') === u) return;
        ['src', 'data-src'].forEach((a) => im.setAttribute(a, u)); ['srcset', 'data-srcset'].forEach((a) => im.setAttribute(a, u)); im.classList.add('lazyloaded'); im.setAttribute('data-p360', u); n++; });
      s.querySelectorAll('[data-fancybox]').forEach((a) => a.setAttribute('href', u));
    });
    document.querySelectorAll('.productView-for').forEach((f) => f.querySelectorAll('.productView-thumbnail').forEach((th, k) => {
      const u = urls[k]; if (!u) return; const im = th.querySelector('img'), lk = th.querySelector('[data-image]');
      if (im && im.getAttribute('src') !== u) { im.setAttribute('src', u); n++; } if (lk) lk.setAttribute('data-image', u); }));
    return n;
  };
  const done = () => root.classList.add('p360-gal-done');
  let tries = 0; swap();
  const iv = setInterval(() => { swap(); if (++tries > 40) { clearInterval(iv); } }, 100);
  document.addEventListener('DOMContentLoaded', () => { swap(); done(); });
  setTimeout(done, 2500); setTimeout(swap, 4500);
})();

// (v2) Texto del botón de compra en la versión B. También en la vista previa.
(function () {
  const t = window.P360AB && window.P360AB.btn;
  if (!t) return;
  const set = () => document.querySelectorAll('.productView-buttons [type=submit], .productView-buttons .button--primary, .sticky-product [type=submit]').forEach((b) => {
    const s = b.querySelector('span') || b; if (s.textContent.trim() && s.textContent.trim() !== t) s.textContent = t;
  });
  set(); document.addEventListener('DOMContentLoaded', set); setTimeout(set, 800); setTimeout(set, 2500);
})();

(function () {
  const AB = window.P360AB;
  if (!AB || AB.preview) return;
  const ids = Object.keys(AB.active).filter((id) => AB.running.includes(id));
  if (!ids.length) return;

  const tag = ids.map((id) => `${id}:${AB.active[id]}`).join(',');
  const send = (name, extra) => ids.forEach((id) => {
    const payload = Object.assign({ test_id: id, variant: AB.active[id], product: AB.product }, extra || {});
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, payload); } catch (_) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload));
  });
  // (v2) contador propio en el portal: una vez por sesión, test y evento
  const HIT = 'https://panambi360-hit.panambi360-cloud.workers.dev/hit';
  const hit = (e) => {
    const h = [];
    ids.forEach((id) => { const k = `p360_hit_${id}_${e}`; let done = false; try { done = sessionStorage.getItem(k); sessionStorage.setItem(k, '1'); } catch (_) {} if (!done) h.push({ t: id, v: AB.active[id], e }); });
    if (!h.length) return;
    const body = JSON.stringify({ h });
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(HIT, new Blob([body], { type: 'text/plain' })))) fetch(HIT, { method: 'POST', body, keepalive: true, mode: 'no-cors' }); } catch (_) {}
  };

  send('p360_ab_exposure'); hit('view');

  document.addEventListener('panambi:added', (e) => {
    if (document.querySelector('[data-pdp]') || document.querySelector('.productView')) { send('p360_ab_add_to_cart', { variant_id: e.detail && e.detail.id }); hit('atc'); }
  });

  // Atributo del carrito: une todas las versiones vistas en la sesión (p. ej. "fit-modelo:b,envio-arriba:a").
  let seen = {};
  try { seen = JSON.parse(sessionStorage.getItem('p360_ab_seen') || '{}'); } catch (_) {}
  ids.forEach((id) => { seen[id] = AB.active[id]; });
  const attr = Object.keys(seen).map((id) => `${id}:${seen[id]}`).join(',');
  let last = null;
  try { last = sessionStorage.getItem('p360_ab_attr'); sessionStorage.setItem('p360_ab_seen', JSON.stringify(seen)); } catch (_) {}
  if (attr !== last) {
    fetch(((window.Panambi && Panambi.routes.cart) || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _p360_ab: attr } }) })
      .then(() => { try { sessionStorage.setItem('p360_ab_attr', attr); } catch (_) {} })
      .catch(() => {});
  }
  window.P360AB.tag = tag;
})();
